import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalContainer from "../../common/ModalContainer";
import getCurrencies from "../../../controllers/settings/currencies/getCurrencies";
import { setCurrencies } from "../../../redux/reducers/settings/currenciesSlice";

const NGN_CURRENCY = {
  _id: "ngn-default",
  name: "Nigerian Naira",
  code: "NGN",
  symbol: "₦",
};

function CustomerDetailWalletCurrencyModal({ open, setOpen, onSelect }) {
  const dispatch = useDispatch();
  const currencies = useSelector((state) => state.currencies.currencies);

  useEffect(() => {
    if (!open || currencies?.length) return;

    getCurrencies().then((res) => {
      if (res?.return && res?.data) {
        dispatch(setCurrencies(res.data));
      }
    });
  }, [open, currencies, dispatch]);

  const currencyOptions = useMemo(() => {
    const others = (currencies || []).filter(
      (currency) => currency?.code !== "NGN",
    );
    return [NGN_CURRENCY, ...others];
  }, [currencies]);

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      title="Select currency"
      subTitle="Choose which wallet currency to top up"
      childClassname="max-w-[520px]"
    >
      <div className="p-4 flex flex-col gap-2">
        {currencyOptions.map((currency) => (
          <button
            key={currency._id || currency.code}
            type="button"
            onClick={() => {
              onSelect?.(currency);
            }}
            className="flex items-center justify-between gap-3 w-full rounded-lg border border-[#E0E0E0] bg-[#F9F9F9] px-4 py-3 text-left hover:border-primary1 hover:bg-[#F0F6FF] transition-colors"
          >
            <div className="flex flex-col gap-0.5 min-w-0">
              <span className="font-semibold text-sm text-[#1A1A1A]">
                {currency.name}
              </span>
              <span className="text-xs text-[#6D7C94]">{currency.code}</span>
            </div>
            <span className="text-lg font-semibold text-primary1 shrink-0">
              {currency.symbol}
            </span>
          </button>
        ))}
      </div>
    </ModalContainer>
  );
}

export default CustomerDetailWalletCurrencyModal;
